interface Props {
    words: string;
}

const Subtitle = ({ words }: Props) => {
    return <h3 className="mb-2 font-semibold text-slate-600 text-lg">{words}</h3>;
};

export { Subtitle };
